The state of a request to replay events for a `WebhookSubscription`.
